import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import template from './ns-link-list.html';

/**
 * `ns-link-list`
 * Creates a lists with a title
 *
 *  @param title @type String @default null @desc array list title
 *  @param active @type Boolean @default false @desc toggles expanded state of list on mobile view(disabled when horizontal attribute is added)
 *  @param links @type Array e.g. [{href, name}] @default null @desc each object in array creates a new link
 *  @attr horizontal @type Attribute @default null @desc forces list to be in a row
 *  @param unnamed slot
 *
 *  @example <ns-link-list title="{{title}} active="true" links="links" horizontal><div>slot content</div></ns-link-list>
 *
 * @customElement
 */
export class NsLinkList extends PolymerElement {

    static get is() { return 'ns-link-list'; }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            active: {
                type: String,
                value: "inactive"
            }
        }
    }

    toggleContainer () {
        this.active = this.active === "active" ? "inactive" : "active";
    }
}

customElements.define(NsLinkList.is, NsLinkList);